import React from 'react';
import { Link } from 'react-router-dom';
import PageTemplate from '../components/PageTemplate';

const AIData = () => {
  const aiDataServices = [
    {
      title: "Data Engineering",
      description: "Build robust data pipelines and infrastructure for seamless data processing and analytics.",
      icon: "fas fa-database",
      link: "/ai-data/data-engineering",
      features: ["Data Architecture", "ETL Pipelines", "Data Warehouse", "Real-time Processing"]
    },
    {
      title: "Analytics & Business Intelligence",
      description: "Transform raw data into actionable insights with advanced analytics and BI solutions.",
      icon: "fas fa-chart-bar",
      link: "/ai-data/analytics-bi",
      features: ["Data Visualization", "Predictive Analytics", "Business Intelligence", "Self-Service Analytics"]
    },
    {
      title: "AI Development",
      description: "Custom AI solutions including machine learning, computer vision, and natural language processing.",
      icon: "fas fa-robot",
      link: "/ai-data/ai-development",
      features: ["Machine Learning", "Computer Vision", "NLP", "Deep Learning"]
    },
    {
      title: "Generative AI",
      description: "Leverage the power of generative AI for content creation, automation, and innovation.",
      icon: "fas fa-magic",
      link: "/ai-data/gen-ai",
      features: ["LLM Integration", "Content Generation", "AI Assistants", "Prompt Engineering"]
    },
    {
      title: "Blockchain Solutions",
      description: "Secure, decentralized solutions using blockchain technology and smart contracts.",
      icon: "fas fa-link",
      link: "/ai-data/blockchain",
      features: ["Smart Contracts", "DeFi Solutions", "NFT Platforms", "Cryptocurrency"]
    },
    {
      title: "MLOps",
      description: "End-to-end machine learning operations for model deployment, monitoring, and management.",
      icon: "fas fa-cogs",
      link: "/ai-data/mlops",
      features: ["Model Deployment", "Continuous Integration", "Model Monitoring", "Automated Retraining"]
    }
  ];

  return (
    <PageTemplate
      title="AI & Data Solutions"
      subtitle="Unlock the power of artificial intelligence and data-driven insights"
      breadcrumb="AI & Data"
    >
      <div className="content-section">
        <div className="two-column">
          <div>
            <h3>Transform Your Business with AI & Data</h3>
            <p>
              We design efficient data pipelines for seamless analysis, unlocking valuable insights with advanced analytics and business intelligence. Our solutions ensure secure and accessible data management while automating processes and decisions with AI.
            </p>
            <p>
              From data engineering to generative AI, we provide comprehensive solutions that help businesses harness the full potential of their data and implement cutting-edge AI technologies.
            </p>
          </div>
          <div>
            <div className="stats-grid">
              <div className="stat-item">
                <span className="stat-number">50+</span>
                <span className="stat-label">AI Projects</span>
              </div>
              <div className="stat-item">
                <span className="stat-number">1TB+</span>
                <span className="stat-label">Data Processed</span>
              </div>
              <div className="stat-item">
                <span className="stat-number">95%</span>
                <span className="stat-label">Accuracy Rate</span>
              </div>
              <div className="stat-item">
                <span className="stat-number">24/7</span>
                <span className="stat-label">Monitoring</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="content-section">
        <h2>Our AI & Data Services</h2>
        <div className="content-grid">
          {aiDataServices.map((service, index) => (
            <div key={index} className="content-card">
              <div className="icon">
                <i className={service.icon}></i>
              </div>
              <h4>{service.title}</h4>
              <p>{service.description}</p>
              <ul className="feature-list">
                {service.features.map((feature, idx) => (
                  <li key={idx}>{feature}</li>
                ))}
              </ul>
              <Link to={service.link} className="btn btn-outline">
                Learn More
              </Link>
            </div>
          ))}
        </div>
      </div>

      <div className="content-section">
        <h2>Technologies We Work With</h2>
        <div className="content-grid">
          <div className="content-card">
            <div className="icon">
              <i className="fab fa-python"></i>
            </div>
            <h4>Programming Languages</h4>
            <p>Python, R, Scala, Java, JavaScript for diverse data and AI applications.</p>
          </div>
          <div className="content-card">
            <div className="icon">
              <i className="fas fa-brain"></i>
            </div>
            <h4>AI/ML Frameworks</h4>
            <p>TensorFlow, PyTorch, Scikit-learn, Keras, and other cutting-edge frameworks.</p>
          </div>
          <div className="content-card">
            <div className="icon">
              <i className="fas fa-cloud"></i>
            </div>
            <h4>Cloud Platforms</h4>
            <p>AWS, Azure, GCP with specialized AI and data services.</p>
          </div>
          <div className="content-card">
            <div className="icon">
              <i className="fas fa-server"></i>
            </div>
            <h4>Big Data Tools</h4>
            <p>Apache Spark, Hadoop, Kafka, Elasticsearch for large-scale data processing.</p>
          </div>
        </div>
      </div>

      <div className="cta-section">
        <h3>Ready to Leverage AI & Data?</h3>
        <p>Let's discuss how our AI and data solutions can transform your business operations.</p>
        <Link to="/contact" className="btn btn-primary">
          Start Your AI Journey
        </Link>
      </div>
    </PageTemplate>
  );
};

export default AIData; 